import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomRadioGroup from "@components/CustomRadioGroup";
import { ButtonTypeSelected } from "@components/ButtonTypeSelected";
import iconCheck from "@assets/img/icon_check_cotizador.svg";
import { SyntheticEvent, useState } from "react";
import CustomCircularProgress from "@components/CustomCircularProgress";
import { ProgressBar } from "@components/ProgressBar";
import { PhoneCodeInput } from "@components/PhoneCodeInput";
import ButtonValidacionIdentidad from "@components/ButtonValidacionForm";
import ButtonFormEnum from "@components/ButtonExpedienteForm";
import CustomUploadFileV2 from "@components/CustomUploadFileV2";
import { StyledSlider } from "@components/CustomSlider";
import { DocumentResponse } from "@interfaces/response";
import { UUID } from "crypto";
import { useAppDispatch } from "@store/store";
import { setModalErrorVisible } from "@store/slices/appSlice";

export const Components = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();

  const [radioValue, setRadioValue] = useState<string>("");
  const [textFieldValue, setTextFieldValue] = useState<string>("");
  const [selectValue, setSelectValue] = useState<string>("");
  const [phoneValue, setPhoneValue] = useState<string>("");
  const [sliderValue, setSliderValue] = useState<number>(50);
  const [selectedButtonType, setSelectedButtonType] = useState<string>("A");
  const [selectedButtonTypeSmall, setSelectedButtonTypeSmall] = useState<string>("12");

  const noop = () => undefined;

  const sliderMarks = [
    { value: 0, label: "0" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 75, label: "75" },
    { value: 100, label: "100" },
  ];

  const defaultMetadata = {
    fileCode: "estado_cuenta_bancario",
    uploadType: "client" as const,
  };

  const mockDocumentValidated: DocumentResponse = {
    id: "123e4567-e89b-12d3-a456-426614174000" as UUID,
    loan_application_id: "123e4567-e89b-12d3-a456-426614174001" as UUID,
    file_category_id: "123e4567-e89b-12d3-a456-426614174002" as UUID,
    client_details_id: "123e4567-e89b-12d3-a456-426614174003" as UUID,
    person_id: null,
    guarantee_id: null,
    url: "https://example.com/documento.pdf",
    legal_text: null,
    status: true,
    created_at: "2023-01-01T00:00:00Z",
    updated_at: "2023-01-01T00:00:00Z",
    file_name: "estado-de-cuenta.pdf",
    validated: true,
    rejected: false,
    sign_client: null,
    file_code: "estado_cuenta_bancario",
  };

  const mockDocumentPendingValidation: DocumentResponse = {
    ...mockDocumentValidated,
    id: "123e4567-e89b-12d3-a456-426614174010" as UUID,
    validated: false,
    file_name: "documento-pendiente.pdf",
    status: false,
  };

  const mockDocumentWithEliminar: DocumentResponse = {
    ...mockDocumentValidated,
    id: "123e4567-e89b-12d3-a456-426614174020" as UUID,
    validated: null,
    file_name: "documento-eliminable.pdf",
  };

  const openModalError = () => {
    dispatch(setModalErrorVisible({ open: true, error: null}));
  }

  return (
    <Container sx={{ pb: 10, pt: 2 }}>
      <Grid container spacing={2}>
        {/* textos */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2">Textos</Typography>
          <hr />
          <Typography variant="h1">Texto H1</Typography>
          <Typography variant="h2">Texto H2</Typography>
          <Typography variant="h3">Texto H3</Typography>
          <Typography variant="h4">Texto H4</Typography>
          <Typography variant="h5">Texto H5</Typography>
          <Typography variant="body1">Texto Body 1</Typography>
          <Typography variant="body2">Texto Body 2</Typography>
          <Typography variant="body3">Texto Body 3</Typography>
        </Grid>
        {/* form helper text */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2">Form Helper Text</Typography>
          <hr />
          <FormHelperText>Helper Text Normal</FormHelperText>
          <FormHelperText error={true}>Helper Text Error</FormHelperText>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* inputs de texto */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2">Input de texto</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2}>
            <FormControl>
              <TextField
                id="textfield"
                name="textfield"
                variant="outlined"
                value={textFieldValue}
                onChange={(event) => setTextFieldValue(event.target.value)}
                error={false}
                helperText="Helper text normal"
                required
                label="Input de texto"
              />
            </FormControl>

            <FormControl>
              <TextField
                id="textfield"
                name="textfield"
                value={textFieldValue}
                onChange={(event) => setTextFieldValue(event.target.value)}
                error={true}
                helperText="Error en el input de texto"
                required
                label="Input de texto con error"
              />
            </FormControl>

            <FormControl>
              <TextField
                id="textfield"
                name="textfield"
                value={textFieldValue}
                onChange={(event) => setTextFieldValue(event.target.value)}
                error={false}
                required
                disabled={true}
                label="Input de texto disabled"
              />
            </FormControl>

            {/* <FormControl>
              <TextField
                id="textfield"
                name="textfield"
                variant="filled"
                value={textFieldValue}
                onChange={(event) => setTextFieldValue(event.target.value)}
                error={false}
                helperText="Helper text normal"
                required
                label="Input de texto filled"
              />
            </FormControl> */}

            {/* <FormControl>
              <TextField
                id="textfield"
                name="textfield"
                variant="standard"
                value={textFieldValue}
                onChange={(event) => setTextFieldValue(event.target.value)}
                error={false}
                helperText="Helper text normal"
                required
                label="Input de texto standard"
              />
            </FormControl> */}
          </Box>
        </Grid>
        {/* select */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2">Select</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2}>
            <FormControl>
              <InputLabel id="select-label" required>
                Select
              </InputLabel>
              <Select
                variant="outlined"
                labelId="select-label"
                label="Select"
                id="select"
                name="select"
                value={selectValue}
                onChange={(event) => setSelectValue(event.target.value)}
                error={false}
                required
              >
                <MenuItem value="1">Option 1</MenuItem>
                <MenuItem value="2">Option 2</MenuItem>
                <MenuItem value="3">Option 3</MenuItem>
              </Select>
              <FormHelperText>Helper text normal</FormHelperText>{" "}
            </FormControl>
            <FormControl error={true}>
              <Select
                id="select"
                name="select"
                value={selectValue}
                onChange={(event) => setSelectValue(event.target.value)}
                error={true}
                required
              >
                <MenuItem value="1">Option 1</MenuItem>
                <MenuItem value="2">Option 2</MenuItem>
                <MenuItem value="3">Option 3</MenuItem>
              </Select>
              <FormHelperText error={true}>Helper text error</FormHelperText>
            </FormControl>
            <FormControl error={true}>
              <Select
                id="select"
                name="select"
                value={selectValue}
                onChange={(event) => setSelectValue(event.target.value)}
                error={false}
                required
              >
                <MenuItem value="1">Option 1</MenuItem>
                <MenuItem value="2">Option 2</MenuItem>
                <MenuItem value="3">Option 3</MenuItem>
              </Select>
            </FormControl>{" "}
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* checkbox */}
        <Grid item xs={12} md={4}>
          <Typography variant="h2">Checkbox</Typography>
          <hr />
          <FormGroup>
            <FormControlLabel control={<Checkbox defaultChecked />} label="Label" />
            <FormControlLabel required control={<Checkbox />} label="Required" />
            <FormControlLabel disabled control={<Checkbox />} label="Disabled" />
          </FormGroup>
        </Grid>

        {/* radio */}
        <Grid item xs={12} md={4}>
          <Typography variant="h2">Radio</Typography>
          <hr />
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="female" control={<Radio />} label="Female" />
              <FormControlLabel value="male" control={<Radio />} label="Male" />
              <FormControlLabel value="other" control={<Radio />} label="Other" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* custom radio group */}
        <Grid item xs={12} md={4}>
          <Typography variant="h2">Custom Radio Group</Typography>
          <hr />
          <CustomRadioGroup
            label={"Gender"}
            name={"gender"}
            value={radioValue}
            onChange={(event: SyntheticEvent<Element, Event>) =>
              setRadioValue((event.target as HTMLInputElement).value)
            }
            options={[
              {
                label: "Female",
                value: "female",
              },
              {
                label: "Male",
                value: "male",
              },
              {
                label: "Other",
                value: "other",
              },
            ]}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* botones */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2">Botones</Typography>
          <hr />

          <Box display="flex" flexDirection="column" gap={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="default" fullWidth>
                  Default Button
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="default" disabled fullWidth>
                  Default Button disabled
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="default_disabled" fullWidth>
                  default_disabled
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="default_disabled" disabled fullWidth>
                  default_disabled disabled
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="contained" fullWidth>
                  Button contained
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="contained" disabled fullWidth>
                  Button contained disabled
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="blue_outlined" fullWidth>
                  Button blue outlined
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="blue_outlined" disabled fullWidth>
                  Button blue outlined disabled
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="green" fullWidth>
                  Button green
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="green" disabled fullWidth>
                  Button green disabled
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="yellow" fullWidth>
                  Button yellow
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button variant="yellow" disabled fullWidth>
                  Button yellow disabled
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* pallete colors */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3">Pallete colors</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" flexDirection="row" gap={2} border="1px solid #d0d0d0" p={2}>
              <Box sx={{ width: 60, height: 60, backgroundColor: theme.palette.primary.main }} />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Primary.Main</Typography>
                <Typography variant="body1">{theme.palette.primary.main}</Typography>
              </Box>
            </Box>

            <Box display="flex" flexDirection="row" gap={2} border="1px solid #d0d0d0" p={2}>
              <Box sx={{ width: 60, height: 60, backgroundColor: theme.palette.primary.dark }} />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Primary.Dark</Typography>
                <Typography variant="body1">{theme.palette.primary.dark}</Typography>
              </Box>
            </Box>

            <Box display="flex" flexDirection="row" gap={2} border="1px solid #d0d0d0" p={2}>
              <Box sx={{ width: 60, height: 60, backgroundColor: theme.palette.primary.light }} />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Primary.Light</Typography>
                <Typography variant="body1">{theme.palette.primary.light}</Typography>
              </Box>
            </Box>

            <Box display="flex" flexDirection="row" gap={2} border="1px solid #d0d0d0" p={2}>
              <Box sx={{ width: 60, height: 60, backgroundColor: theme.palette.primary.base }} />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Primary.Base</Typography>
                <Typography variant="body1">{theme.palette.primary.base}</Typography>
              </Box>
            </Box>

            <Box display="flex" flexDirection="row" gap={2} border="1px solid #d0d0d0" p={2}>
              <Box sx={{ width: 60, height: 60, backgroundColor: theme.palette.primary?.accent }} />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Primary.Accent</Typography>
                <Typography variant="body1">{theme.palette.primary?.accent}</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* circular progress */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3">Custom Circular Progress</Typography>
          <hr />
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
            <CustomCircularProgress size={150} />
          </Box>
        </Grid>

        {/* progress bar */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3">Progress bar</Typography>
          <hr />
          <ProgressBar totalSteps={10} currentStep={5} />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* Slider (StyledSlider) */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3">StyledSlider (Custom)</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2} px={1}>
            <Typography variant="body2" color="text.secondary">
              Valor: {sliderValue}
            </Typography>
            <StyledSlider
              aria-label="slider-demo"
              min={0}
              max={100}
              step={5}
              marks={sliderMarks}
              value={sliderValue}
              onChange={(_event, newValue) => setSliderValue(newValue as number)}
              valueLabelDisplay="on"
            />
          </Box>
        </Grid>

        {/* phone input */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3">Phone Input</Typography>
          <hr />
          <PhoneCodeInput
            name="code_confirm"
            value={phoneValue}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPhoneValue(event.target.value);
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* ButtonValidacionIdentidad */}
        <Grid item xs={6}>
          <Typography variant="h3">Variantes boton Validacion Identidad</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <ButtonValidacionIdentidad />
              </Grid>
              <Grid item xs={12} md={6}>
                <ButtonValidacionIdentidad isCompleted />
              </Grid>
              <Grid item xs={12} md={12}>
                <ButtonValidacionIdentidad isCompleted documentStatus />
              </Grid>

              <Grid item xs={12} md={12}>
                <ButtonValidacionIdentidad isCompleted={false} />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* ButtonFormEnum */}
        <Grid item xs={6}>
          <Typography variant="h3">Variantes boton Expediente</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <ButtonFormEnum formStatus={null} onClick={noop} />
              </Grid>
              <Grid item xs={12} md={12}>
                <ButtonFormEnum formStatus="COMPLETO" onClick={noop} />
              </Grid>
              <Grid item xs={12} md={12}>
                <ButtonFormEnum formStatus="VALIDADO" onClick={noop} />
              </Grid>

              <Grid item xs={12} md={12}>
                <ButtonFormEnum formStatus="INCIDENCIA" onClick={noop} />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        {/* CustomUploadFileV2 */}
        <Grid item xs={6}>
          <Typography variant="h2">Upload file</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <CustomUploadFileV2
                  inputName="upload_demo_4"
                  setUploadedFile={noop}
                  metadata={defaultMetadata}
                  optionalName="Estado de cuenta bancario"
                  optionalDescription="Ejemplo deshabilitado..."
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <CustomUploadFileV2
                  inputName="upload_demo_2"
                  setUploadedFile={noop}
                  metadata={defaultMetadata}
                  optionalName="Estado de cuenta bancario"
                  optionalDescription="Ejemplo vacío..."
                  required
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <CustomUploadFileV2
                  inputName="upload_demo_8"
                  uploadedFile={mockDocumentWithEliminar}
                  setUploadedFile={noop}
                  metadata={defaultMetadata}
                  optionalName="Estado de cuenta bancario"
                  optionalDescription="Documento cargado..."
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <CustomUploadFileV2
                  inputName="upload_demo_6"
                  uploadedFile={mockDocumentValidated}
                  setUploadedFile={noop}
                  metadata={defaultMetadata}
                  optionalName="Estado de cuenta bancario"
                  optionalDescription="Ejemplo validado..."
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomUploadFileV2
                  inputName="upload_demo_7"
                  uploadedFile={mockDocumentPendingValidation}
                  setUploadedFile={noop}
                  metadata={defaultMetadata}
                  optionalName="Estado de cuenta bancario"
                  optionalDescription="Ejemplo rechazado..."
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* ButtonTypeSelected */}
        <Grid item xs={6}>
          <Typography variant="h2">Button Type</Typography>
          <hr />
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                  <ButtonTypeSelected
                    title="Opción A"
                    isSelected={selectedButtonType === "A"}
                    onClick={() => setSelectedButtonType("A")}
                    isMovile={isMobileOrTablet}
                    width="140px"
                    widthMoviles="120px"
                    height="60px"
                    heightMoviles="56px"
                    icon={iconCheck}
                    width_icon="22px"
                    height_icon="22px"
                  />
                  <ButtonTypeSelected
                    title="Opción B"
                    isSelected={selectedButtonType === "B"}
                    onClick={() => setSelectedButtonType("B")}
                    isMovile={isMobileOrTablet}
                    width="140px"
                    widthMoviles="120px"
                    height="60px"
                    heightMoviles="56px"
                    icon={iconCheck}
                    width_icon="22px"
                    height_icon="22px"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={12} mt={2}>
                <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                  <ButtonTypeSelected
                    title="12"
                    isSelected={selectedButtonTypeSmall === "12"}
                    onClick={() => setSelectedButtonTypeSmall("12")}
                    isMovile={isMobileOrTablet}
                    width="50px"
                    widthMoviles="44px"
                    height="40px"
                    heightMoviles="36px"
                    icon={iconCheck}
                    width_icon="18px"
                    height_icon="18px"
                    font_size="12px"
                    font_size_movil="11px"
                  />
                  <ButtonTypeSelected
                    title="24"
                    isSelected={selectedButtonTypeSmall === "24"}
                    onClick={() => setSelectedButtonTypeSmall("24")}
                    isMovile={isMobileOrTablet}
                    width="50px"
                    widthMoviles="44px"
                    height="40px"
                    heightMoviles="36px"
                    icon={iconCheck}
                    width_icon="18px"
                    height_icon="18px"
                    font_size="12px"
                    font_size_movil="11px"
                  />
                  <ButtonTypeSelected
                    title="36"
                    isSelected={selectedButtonTypeSmall === "36"}
                    onClick={() => setSelectedButtonTypeSmall("36")}
                    isMovile={isMobileOrTablet}
                    width="50px"
                    widthMoviles="44px"
                    height="40px"
                    heightMoviles="36px"
                    icon={iconCheck}
                    width_icon="18px"
                    height_icon="18px"
                    font_size="12px"
                    font_size_movil="11px"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Modal errors */}

        <Grid container spacing={2} mt={2}>
          {/* botones */}
          <Grid item xs={12} md={12}>
            <Typography variant="h2">Modal Errors</Typography>
            <hr />

            <Box display="flex" flexDirection="column" gap={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Button variant="default" fullWidth onClick={openModalError}>
                    Open Modal Error
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
